// source: https://yeun.github.io/open-color/
const palette = {
  gray: [
    '#f8f9fa',
    '#f1f3f5',
    '#e9ecef',
    '#dee2e6',
    '#ced4da',
    '#adb5bd',
    '#868e96',
    '#495057',
    '#343a40',
    '#212529',
  ],
  cyan: [
    '#e3fafc',
    '#c5f6fa',
    '#99e9f2',
    '#66d9e8',
    '#3bc9db',
    '#22b8cf',
    '#15aabf',
    '#1098ad',
    '#0c8599',
    '#0b7285',
  ],
  pink: [
    '#ff99a0',
    '#eb8d9a',
    '#b26b6f',
    '#F5C1C4',
  ],
  green: [
    '#CCFBE5',
    '#7FD1AE',
    '#5EB5A6',
    '#47999A',
    '#3A7D88',
    '#346272',
    '#2F4858',
  ]
};

export default palette;